import { createSelector } from 'reselect'
import findLessonByID from 'helpers/findLessonByID'
import { getLibraryObjectName } from 'helpers/store/getLibraryObjectName'
import entityTypesEnum from 'helpers/enums/entityTypesNames'

const getPreview = state => state.preview
const getEntities = state => state.lessons

const storeAddToPrivateLibrarySelector = createSelector(
	[getPreview, getEntities],
	(preview, entities) => {
		let lessons = null
		let bundles = null
		const entity = findLessonByID(preview.entity_ID, entities)
		if (entity) {
			const entityType = getLibraryObjectName(entity.library_object_type)
			lessons = (entityType === entityTypesEnum.LESSON) ? [entity.data.id] : null
			bundles = (entityType === entityTypesEnum.BUNDLE) ? [entity.data.id] : null
		}

		return {
			lessons,
			bundles,
		}
	}
)

export default storeAddToPrivateLibrarySelector
